import {ValueObject} from '@s-ui/domain'

export class UserFormDataRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {String} data.userId
   * @param {String} data.name
   * @param {String} data.lastName
   * @param {String} data.email
   * @param {String} data.phone
   **/

  static validate({adId, userId, name, lastName, email, phone, validationError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''

    if (!checkValidData(adId)) throw validationError(`Invalid user adId => ${adId}`)
    if (!checkValidData(userId)) throw validationError(`Invalid user userId => ${userId}`)
    if (!checkValidData(name)) throw validationError(`Invalid user name => ${name}`)
    if (!checkValidData(lastName)) throw validationError(`Invalid user lastName => ${lastName}`)
    if (!checkValidData(email)) throw validationError(`Invalid user email => ${email}`)
    if (!checkValidData(phone)) throw validationError(`Invalid user phone => ${phone}`)
  }
}
